module.exports = __webpack_public_path__ + "img/proyecto-ads.3a47431.jpg";